export const sidebar = {
  minWidth: 360,
  maxWidth: 720,
  defaultWidth: 400,
  /** Margin reserved between the docked panel and the host page (matches `mr-6`). */
  dockedGutterPx: 24,
  dockedContentMinPx: 320,
};

export const floating = {
  minHeight: 280,
  maxHeight: 720,
  defaultHeight: 440,
};

export const storageKeys = {
  sidebar: 'lb.contextChat.sidebar',
};

/**
 * Routes where the chat sidebar is allowed to render. Matches the base
 * path (e.g. `/meetings`) and its sub-paths (e.g. `/meetings/<id>`).
 * Anywhere not listed here, the sidebar stays hidden even if the user
 * had it open before navigating.
 */
export const showPaths = ['/meetings', '/feed'];
